import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { SendIcon } from 'lucide-react';
import { Avatar } from '../components/Avatar';
import { CommentItem } from '../components/CommentItem';
import { PageHeader } from '../components/PageHeader';
import { EmptyState } from '../components/ui/EmptyState';
import { currentUser } from '../data/user';
import { useLocale } from '../contexts/LocaleContext';
import { useSocial } from '../contexts/SocialContext';
export function Comments() {
  const {
    postId = ''
  } = useParams();
  const {
    t
  } = useLocale();
  const social = useSocial();
  const [draft, setDraft] = useState('');
  const comments = social.commentsFor(postId);
  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    const text = draft.trim();
    if (text.length === 0) return;
    social.addComment(postId, text);
    setDraft('');
  };
  return <div className="flex min-h-full flex-col px-2 pb-2" data-id="element-2455" data-mp="ktazyoin609f">
      <PageHeader title={t('comments.title')} subtitle={t('comments.count', {
      n: social.commentCount(postId)
    })} showBack data-id="element-2456" data-mp="krq5eywbuhbk" />

      <div className="flex-1" data-id="element-2457" data-mp="y8qoko3r0n7w">
        {comments.length === 0 ? <EmptyState title={t('comments.empty.title')} body={t('comments.empty.body')} data-id="element-2458" data-mp="y5w4wysk76fj" /> : <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-2459" data-mp="p7k6ialgb4cj">
            {comments.map(comment => <CommentItem key={comment.id} comment={comment} data-id="element-2460" data-mp="aieb6xpqhy9x" />)}
          </ul>}
      </div>

      <form onSubmit={submit} className="mt-3 flex items-center gap-2 border-t border-sand-line bg-sand py-2" data-id="element-2461" data-mp="faeg74knvhdd">
        <Avatar src={currentUser.avatar} name={currentUser.name} size={34} data-id="element-2462" data-mp="1fv9wi1ljtps" />
        <input value={draft} onChange={event => setDraft(event.target.value)} placeholder={t('comments.placeholder')} aria-label={t('comments.placeholder')} className="h-11 min-w-0 flex-1 rounded-pill border border-sand-line bg-white/80 px-3 text-[13.5px] text-deep placeholder:text-muted focus:border-deep/40" data-id="element-2463" data-mp="6hubpnhouikm" />
        <button type="submit" disabled={draft.trim().length === 0} aria-label={t('comments.send')} className="grid h-11 w-11 shrink-0 place-items-center rounded-pill bg-deep text-gold transition-colors duration-150 ease-brand disabled:opacity-40" data-id="element-2464" data-mp="34snx6009y2nj">
          <SendIcon size={17} data-id="element-2465" data-mp="3sis1k9lae6fl" />
        </button>
      </form>
    </div>;
}